import { doc, getDoc, getFirestore } from 'firebase/firestore';
import app from '../config/firebase';

const db = getFirestore(app);

const toNumber = (value) => {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeFinance = (finance = {}) => ({
  availableArtworkValuePence: toNumber(finance.availableArtworkValuePence),
  subscribedArtists: toNumber(finance.subscribedArtists),
  totalTransactedVolumePence: toNumber(finance.totalTransactedVolumePence),
});

const normalizeArtists = (artists = {}) => ({
  totalArtists: toNumber(artists.totalArtists),
  activeArtists: toNumber(artists.activeArtists),
  inactiveArtists: toNumber(artists.inactiveArtists),
  pendingRegistrationRequests: toNumber(artists.pendingRegistrationRequests),
});

const normalizeArtworks = (artworks = {}) => ({
  publiclyAvailable: toNumber(artworks.publiclyAvailable),
  sold: toNumber(artworks.sold),
  draft: toNumber(artworks.draft),
});

const normalizeCollectors = (collectors = {}) => ({
  totalSignups: toNumber(collectors.totalSignups),
  identityVerified: toNumber(collectors.identityVerified),
});

const normalizeInsightsSnapshot = (data = {}) => ({
  schemaVersion: toNumber(data.schemaVersion),
  generatedAtMs: toNumber(data.generatedAtMs),
  currency: data.currency || 'GBP',
  finance: normalizeFinance(data.finance),
  artists: normalizeArtists(data.artists),
  artworks: normalizeArtworks(data.artworks),
  collectors: normalizeCollectors(data.collectors),
});

export const fetchLatestInsightsSnapshot = async () => {
  const snapshot = await getDoc(doc(db, 'admin_insights', 'current'));
  if (!snapshot.exists()) {
    return null;
  }

  return normalizeInsightsSnapshot(snapshot.data());
};
